// removed by extract-text-webpack-plugin
module.exports = {"fileInput":"_1gKPqZmMby textInput","noFile":"_1a90fWwOBf","disabled":"_2EtWfKJYG9","icon":"_1NNO03GU26","dragging":"_1r6NIc782p","clearBtn":"_3xUO5HOUQn","relatedAccts":"_3BBkQorFKJ"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Documents/AddDocumentModal/AddDocumentModal.module.less
// module id = 982
// module chunks = 3